import Mode from './Mode.es6';

// Step Model
export default class {
    /**
     * @param name Name of the step
     * @param mode If this ste
     * @param Configurator
     */
    constructor(name, mode, Configurator) {
        this.Configurator   = Configurator;
        this.level          = Configurator.PURCHASE_LEVEL_LOW;
        this.overlay        = Configurator.Overlay.CONTAINER_POPUP;
        this.name           = name;
        this.mode           = mode || Mode.DESIGN_HASH;
        this.data           = {}; // Storage data for this step
        this.main           = false;
        this.baseUrl        = 'mixer/design/step/';
        this.stopOnSubmit   = true;
        this.useVI          = true; // Use view interface (buttons)
        this.position       = null;
    }

    get done() {
        // Step is done if it does not run in this mode
        if (!Mode.check(this.mode)) {
            // we are done!
            return true;
        }
        // If step is not ready we do not validate
        if (!this.ready) {
            return false;
        }
        return this.validate();
    }

    get relativeUrl() { return this.baseUrl + this.url }

    get start() {
        const Configurator = this.Configurator;

        // Set step to false in case it was trigger before
        this.ready = false;

        // Change the configurator mode to the mode of the actual step
        if (this.mode !== Mode.DESIGN_BOTH) Configurator.mode = this.mode;

        // Find first undone required steps and run it
        const required = this.required().find(name => !Configurator.Progress.get(name).done);
        if (required) return Configurator.Progress.get(required).start;

        // We call an url on overlay
        if (this.url && this.Configurator.Progress.allowAutomaticStart()) {
            this.Configurator.Overlay.call(
                URI(this.relativeUrl).addQuery('btype', this.Configurator.btype).toString(),
                this.overlay
            );
        }

        // Prepare/Change UX
        Configurator.Overlay.summary(this.level); // Change summary according to this step
        Configurator.Overlay.showViewInterface(this.useVI); // We show views navigations buttons
        this.Configurator.Overlay.select(this.name); // Select the button for this step
        if (this.mode === Mode.DESIGN_HASH) Configurator.Design.Tin.setDesign(Configurator.id, true); // Reset Tin Component
        if (this.mode !== Mode.DESIGN_USER) App.Interface.Notification.reset(); // Remove Notifications
        if (this.position) Configurator.Preview.setTinPosition(this.position);
        return this.run();
    }

    /**
     * Save values for step
     * @param values values to safe
     * @param commit we use the values to commit changes in step
     */
    save(values, commit = true) {
        commit ? this.commit(values) : this.values = values;
        this.Configurator.data = this.Configurator.Progress.data;
    }
    required() {
        return [];
    }
    complete() {
        this.ready = true;
    }

    set ready(value) {
        this._ready = value;
    }
    get ready() {
        return this._ready ?? false;
    }
}
